import { HeroSection } from '../widgets';
import Image from '../../assets/terms.jpg';

export function Terms() {
    return (
        <>
            <HeroSection image={Image} title={'Terms & Conditions'} description={'Last Edited: April 19, 2025.'} />
            <TermsConditions />
        </>
    );
}

function TermsConditions() {
    return (
        <div className="mx-auto px-7 py-12 bg-white my-8">
            <div className="space-y-5">
                <Introduction />
                <ServiceOverview />
                <Eligibility />
                <AccountRegistration />
                <AcceptableUse />
                <ThirdParty />
                <SubscriptionPayment />
                <DataPrivacy />
                <IntellectualProperty />
                <Termination />
                <DisclaimersLimitations />
                <GoverningLaw />
                <Contact />
            </div>
        </div>
    );
}

function Introduction() {
    return (
        <section className="border-b border-gray-100">
            <p className="text-gray-600 leading-relaxed mb-2">
                Welcome to Corella! These Terms of Service ("Terms") govern your access to and use of our website, web app, and services (“Corella” or the “Service”), operated by Polibuzz Private Limited.
                <br />By accessing or using Corella, you agree to be bound by these Terms. If you do not agree, do not use the service.
            </p>
        </section>
    )
}

function ServiceOverview() {
    return (
        <section className="border-b border-gray-100">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Overview of Service</h2>
            <p className="text-gray-600 leading-relaxed">Corella provides a unified workspace that integrates task management, communication, scheduling, and external productivity tools (e.g., Gmail, Outlook, Microsoft Teams, Google Drive, and Microsoft 365). Users can manage tasks, collaborate, and streamline workflow across tools in one platform.</p>
        </section>
    )
}

function Eligibility() {
    return (
        <section className="border-b border-gray-100 pb-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Eligibility</h2>
            <p className="text-gray-600 leading-relaxed">To use Corella, you must be at least 13 years old or the minimum digital age in your country, and legally capable of entering into a binding agreement.</p>
        </section>
    )
}

function AccountRegistration() {
    return (
        <section className="border-b border-gray-100 pb-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Account Registration</h2>
            <p className="text-gray-600 leading-relaxed">You agree to provide accurate, complete, and up-to-date information during signup. You are responsible for maintaining the confidentiality of your credentials and for all activity that occurs under your account.</p>
            <p className="pl-1 text-gray-600 leading-relaxed mb-4">You must not:</p>
            <ul className="pl-8 list-disc text-gray-600 space-y-2">
                <li>Use false information or impersonate others</li>
                <li>Share your login credentials with unauthorized users</li>
            </ul>
        </section>
    )
}

function AcceptableUse() {
    return (
        <section className="border-b border-gray-100">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Acceptable Use</h2>
            <p className="text-gray-600 leading-relaxed mb-4">You agree not to misuse the platform. Prohibited behavior includes:</p>
            <ul className="pl-8 list-disc text-gray-600 space-y-2">
                <li>Violating any law or regulation</li>
                <li>Disrupting the security or functionality of the service</li>
                <li>Sending spam or phishing messages</li>
                <li>Attempting unauthorized access to third-party accounts or systems</li>
            </ul>
        </section>
    )
}

function ThirdParty() {
    return (
        <section className="border-b border-gray-100">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Third-Party Integrations</h2>
            <p className="text-gray-600 leading-relaxed mb-4">You may authorize Corella to connect with third-party services such as Google Workspace, Microsoft 365, and Microsoft Teams. You acknowledge and agree that:</p>
            <ul className="pl-8 list-disc text-gray-600 space-y-2">
                <li>These services are governed by their own terms and privacy policies.</li>
                <li>Corella accesses only the minimum data required to enable platform features.</li>
                <li>You can revoke access at any time from within your account settings or from the third-party platform.</li>
            </ul>
        </section>
    )
}

function SubscriptionPayment() {
    return (
        <section className="border-b border-gray-100">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Subscription & Payment</h2>
            <p className="text-gray-600 leading-relaxed mb-4">Some features may be available only through paid plans. By subscribing, you agree to:</p>
            <ul className="pl-8 list-disc text-gray-600 space-y-2">
                <li>Pay applicable fees according to your selected plan</li>
                <li>Authorize recurring billing (wherever applicable)</li>
                <li>Cancel subscriptions before the renewal date to avoid further charges</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mb-4">Prices and plans are subject to change with prior notice.</p>
        </section>
    )
}

function DataPrivacy() {
    return (
        <section className="border-b border-gray-100 pb-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Data Privacy</h2>
            <p className="text-gray-600 leading-relaxed">Your use of Corella is also governed by our Privacy Policy, which describes how we collect, use, and protect your data.</p>
        </section>
    )
}

function IntellectualProperty() {
    return (
        <section className="border-b border-gray-100">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Intellectual Property</h2>
            <p className="text-gray-600 leading-relaxed mb-4">Corella and its underlying software, branding, and content are owned by Polibuzz Pvt. Ltd and protected under intellectual property laws. You may not:</p>
            <ul className="pl-8 list-disc text-gray-600 space-y-2">
                <li>Copy, modify, distribute, or reverse engineer the platform</li>
                <li>Use our branding without permission</li>
            </ul>
        </section>
    )
}

function Termination() {
    return (
        <section className="border-b border-gray-100">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Termination</h2>
            <p className="text-gray-600 leading-relaxed mb-4">We may suspend or terminate your access to Corella if:</p>
            <ul className="pl-8 list-disc text-gray-600 space-y-2">
                <li>You violate these Terms</li>
                <li>Required by law or regulatory request</li>
                <li>Service discontinuation or technical limitation</li>
            </ul>
        </section>
    )
}

function DisclaimersLimitations() {
    return (
        <section className="border-b border-gray-100">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">10. Disclaimers & Limitation of Liability</h2>
            <p className="text-gray-600 leading-relaxed mb-4">Corella is provided “as is” and “as available”. We do not guarantee:</p>
            <ul className="pl-8 list-disc text-gray-600 space-y-2">
                <li>Continuous availability</li>
                <li>Error-free operation</li>
                <li>Suitability for your specific purposes</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mb-4"><strong>To the fullest extent permitted by law</strong>, Corella shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service.</p>
        </section>
    )
}

function GoverningLaw() {
    return (
        <section className="border-b border-gray-100 pb-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">11. Governing Law</h2>
            <p className="text-gray-600 leading-relaxed">These Terms are governed by and construed under the laws of [Insert Jurisdiction], without regard to its conflict of laws principles.</p>
        </section>
    )
}

function Contact() {
    return (
        <section className="border-b border-gray-100">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">12. Contact Us</h2>
            <p className="text-gray-600 leading-relaxed mb-4">For questions regarding these Terms, please contact:</p>
            <ul className="pl-8 list-disc text-gray-600 space-y-2">
                <li><a href='mailto:contact@corella.work' className='text-blue-600'>contact@corella.work</a></li>
                <li><a href='/' className=' text-blue-600'>www.corella.work</a></li>
            </ul>
        </section >
    )
}